<template>
  <Modal title="添加推荐老师" v-model="visible" width="1200px">
    <Form :label-width="70" :show-message="false">
      <Row>
        <Col :xs="11" :sm="8" :md="5">
        <Form-item label="类型">
        <Select v-model.number="queryParam.category" placeholder="全部"
                @on-change="search" clearable >
          <Option v-for="item in teacherCategoryList"
                  :value="item.code" :key="item.code">{{ item.text }}</Option>
        </Select>
        </Form-item>
        </Col>
        <Col :xs="11" :sm="8" :md="5">
        <Form-item label="授课类型">
        <Select v-model.number="queryParam.tchType" placeholder="全部"
                @on-change="search" clearable data-value="-1">
          <Option value="-1">全部</Option>
          <Option value="0">未分配</Option>
          <Option value="1">外教</Option>
          <Option value="2">中教</Option>
          <Option value="3">陪练</Option>
        </Select>
        </Form-item>
        </Col>
        <Col :xs="11" :sm="8" :md="5">
        <Form-item label="口音" prop="tchId" :label-width="65">
          <Select v-model.number="queryParam.accent" placeholder="全部"
                  @on-change="search" clearable data-value="-1">
            <Option value="2">美音</Option>
            <Option value="1">英音</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :xs="11" :sm="8" :md="5">
        <Form-item label="性别" prop="tchId" :label-width="65">
          <Select v-model.number="queryParam.sex" placeholder="全部"
                  @on-change="search" clearable data-value="-1">
            <Option value="1">男</Option>
            <Option value="2">女</Option>
          </Select>
        </Form-item>
        </Col>
      </Row>
    <Row :gutter="12">
      <Col :xs="11" :sm="8" :md="13">
      <Form-item label="买断时间">
      <Col span="11">
      <Date-picker type="date" format="yyyy-MM-dd" placeholder="生效时间"
                   @on-change="startTimeDateChange"
                   v-model="queryParam.useStartDate"></Date-picker>
      </Col>
      <Col span="11">
          <TimePicker format="HH:mm" v-model="queryParam.startDate" placeholder="上课开始时间" style="width: 112px" :steps="[1, 30]" @on-change="startTimeChange"></TimePicker>
          <!--<TimePicker format="HH:mm" v-model="queryParam.endDate" placeholder="上课结束时间" style="width: 112px" :steps="[1, 30]" @on-change="endTimeChange"></TimePicker>-->
      </Col>
      </Form-item>
    </Col>
    <Col :xs="11" :sm="8" :md="4">
    <Form-item label="老师ID" prop="id" :label-width="65">
      <Input  name="id" v-model="queryParam.id"></Input>
    </Form-item>
    </Col>
    <Col :xs="11" :sm="8" :md="4">
    <Form-item label="昵称" prop="name" :label-width="65">
      <Input placeholder="支持模糊搜索" name="name" v-model="queryParam.name"></Input>
    </Form-item>
    </Col>
      <Button type="primary" @click="searchTch">搜索</Button>
    </Row>
    </Form>
    <RecommendList ref="dataList" :onLoading="onLoading" style="margin-top: 10px" :loading="searchLoading" :tableColumns="title"
          listUrl="/tch/searchTchInfo" :params="queryParam" :reload="reload" @on-selection-change="selectChange" :reset="reset"></RecommendList>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingUpdate" @click="addTch">保存</Button>
    </div>
  </Modal>
</template>
<script>
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
  export default {
    name: 'RecommendTeacherModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      uid: {
        type: Number,
        default: null
      },
    },
    data () {
      let $constant = this.$constant
      return {
        visible: false,
        RecommendParam: {},
        ruleRecommend: {},
        loadingUpdate: false,
        endTimeDate: '',
        searchLoading: false,
        reload: 0,
        rankScoreSeq: 0,
        reasonMap: new Map(),
        reset: false,
        formData: {
          selectList: [],
        },
        teacherCategoryList: $constant.teacherCategory,
        queryParam: {
          name: '',
          sex: null,
          id: null,
          category: null,
          tchType: null,
          accent: null,
          useStartDate: '',
          useStartTime: '',
          startDate: '',
          endDate: '',
          startTime: '',
          endTime: '',
        },
        dataList: [],
        title: [
          {
            type: 'selection',
            align: 'center',
            width: 70,
          },
          {
            title: 'ID/姓名',
            width: 220,
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: row.tchId + '-' + row.firstName + ' ' + row.lastName,
                score: row.monthRankScore
              })
            }
          },
          {
            title: '类型',
            width: 90,
            render: (h, params) => {
              let row = params.row
              let cons = this.$constant.getEnum(this.$constant.teacherCategory, row.category)
              return h('span', cons && cons.text)
            }
          },
          {
            title: '授课类型',
            render: (h, params) => {
              let row = params.row
              let cons = this.$constant.getEnum(this.$constant.tchType, row.tchType)
              return h('span', cons && cons.text)
            }
          },
          {
            title: '性别',
            width: 80,
            render: (h, params) => {
              let row = params.row
              let cons = this.$constant.getEnum(this.$constant.sex, row.sex)
              return h('span', cons && cons.text)
            }
          },
          {
            title: '口音',
            width: 90,
            render: (h, params) => {
              let row = params.row
              let cons = this.$constant.getEnum(this.$constant.accent, row.accent)
              return h('span', cons && cons.text)
            }
          },
          {
            title: '年龄',
            key: 'age',
            width: 80,
          },
          {
            title: '推荐理由',
            key: '',
            render: (h, params) => {
              let self = this
              let row = params.row
              return h('Input', {
                domProps: {
                  value: ''
                },
                on: {
                  input: function (event) {
                    self.updateReson(row, event)
                  }
                }
              })
            }
          },
        ],
      }
    },
    methods: {
      onLoading (loading) {
        if (!loading) {
          this.loadMonthRankScores()
        }
      },
      loadMonthRankScores () {
        const table = this.$refs.dataList && this.$refs.dataList.tableData
        if (!table || !table.length) {
          return
        }
        const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
        const seq = ++this.rankScoreSeq
        const self = this
        fetchTchScoreMap(this.$http, ids).then(function (map) {
          if (seq !== self.rankScoreSeq) {
            return
          }
          applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
        })
      },

      startTimeChange (val) {
        this.queryParam.startTime = val && parseInt(this.$dateUtil.getSecondByHm(val))
      },
      endTimeChange (val) {
        this.queryParam.endTime = val && parseInt(this.$dateUtil.getSecondByHm(val))
      },
      updateReson (row, event) {
        let map = this.reasonMap
        map.set(row.tchId, event)
      },
      selectChange (val) {
        this.formData.selectList = val
      },
      search () {
        let self = this
        self.reload = new Date().getTime()
      },
      searchTch () {
        if (this.visible === false) {
          return
        }
        this.search()
      },
      startTimeDateChange (value) {
        this.queryParam.useStartTime = value && parseInt(this.$moment(value, 'YYYY-M-D').format('X'))
      },
      addTch () {
        let self = this
        self.loadingUpdate = true
        let list = this.formData.selectList
        let map = this.reasonMap
        if (!list || list.length <= 0) {
          this.$Message.warning('请选择要添加的老师!')
          self.loadingUpdate = false
          return
        }
        let tchIds = []
        for (let i in list) {
          if (!map.get(list[i].tchId)) {
            this.$Message.warning('推荐理由不能为空!')
            self.loadingUpdate = false
            return
          }
          list[i].reason = map.get(list[i].tchId)
          tchIds.push(list[i].tchId)
          list[i].uid = this.uid
        }
        // 查询有冲突的老师
        let isPass = true
        if (tchIds) {
          let searchParams = {uid: this.uid, tchIds: tchIds, status: 1, pageSize: 1000}
          self.$http.get('/tchRecommend/list', {params: searchParams}).then(function (res) {
            if (res.data.data) {
              let tchList = res.data.data
              if (tchList && tchList.length > 0) {
                isPass = false
              }
              for (let i in tchList) {
                self.$Message.warning('已经推荐' + tchList[i].firstName + '-' + tchList[i].lastName)
              }
              self.loadingUpdate = false
            }
            if (isPass) {
              self.$http.post('/tchRecommend/insertRecommend', {}, {
                transformRequest: [function (data, headers) {
                  return JSON.stringify(self.formData.selectList)
                }],
                headers: {'Content-Type': 'application/json;charset=utf-8'},
              }).then(function (res) {
                if (res) {
                  self.$Message.success('新增成功!')
                  self.loadingUpdate = false
                  self.visible = false
                  return
                }
              }).catch(function (e) {
                self.loadingUpdate = false
              })
            }
          })
        }
      },
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (!val) {
          this.queryParam = {}
          this.reset = true
          this.formData.selectList = []
          this.reasonMap = new Map()
          this.$emit('on-close', false)
        } else {
          this.reset = false
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RecommendTeacherModal.vue?45de860c